import { useEffect, useState } from "react";
import { Scheduling } from "../models/schedule";
import { fetchScheduling } from "../api/fetchScheduling";

function useScheduling(schedulingId?: string) {
    const [loading, setLoading] = useState<boolean>(false);
    const [scheduling, setScheduling] = useState<Scheduling | undefined>(undefined);

    useEffect(() => {
        if(schedulingId) getScheduling();
    }, [schedulingId]);

    const getScheduling = async () => {
        setLoading(true);
        const data = await fetchScheduling(schedulingId!);
        setScheduling(data);
        setLoading(false);
    }

    return { loading, scheduling}
}

export default useScheduling;